import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminPanelService } from '../../data/admin-panel.service';
import { SystemDictionary, SystemDictionaryBlock } from '../../data/system-dictionary';
import { DictionaryEditorDialogComponent } from './dictionary-editor-dialog/dictionary-editor-dialog.component';

@Component({
	selector: 'app-dictionaries-editor',
	templateUrl: './dictionaries-editor.component.html',
	styleUrls: ['./dictionaries-editor.component.scss']
})
export class DictionariesEditorComponent implements OnInit {

  dictionaries: SystemDictionary[]
  dictsMap = new Map<string, SystemDictionary[]>();
	dictionariesWithTitle: SystemDictionaryBlock[] = []

	loadingSpinner = true;

	constructor(
		private dialog: MatDialog,
		protected adminPanelService: AdminPanelService
	) { }

	ngOnInit(): void {
		this.adminPanelService.getSystemDictionaries().subscribe(dicts => {
			this.dictionaries = dicts;
			this.sortByClazz()
			this.loadingSpinner = false;
		})
	}

	sortByClazz() {
		this.dictionaries.forEach(cond => {
			if (!this.dictsMap.has(cond.clazz)) {
				this.dictsMap.set(cond.clazz, [])
			}

			this.dictsMap.get(cond.clazz).push(cond)
		})

		this.dictsMap.forEach((val, key) => {
			this.dictionariesWithTitle.push({
				title: this.adminPanelService.dictsMap.get(key),
				dictionaries: val
			})
		})
	}

	editDict(dictionary: SystemDictionary, index: number, jindex: number) {
		const dialogRef = this.dialog.open(DictionaryEditorDialogComponent, {
			data: {
				dictionary
			},
			panelClass: 'dictionary-editor-dialog'
		});

		dialogRef.afterClosed().subscribe(newDict => {
			if (newDict && newDict instanceof SystemDictionary) {
				this.dictionariesWithTitle[index].dictionaries[jindex] = newDict
			}
		})
	}
}
